export default "__VITE_ASSET__47a1c0c9__"